import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import StickyNav from './components/StickyNav';

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/ui/login" replace />;
  }

  return (
    <>
      <StickyNav />
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
